import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import { Text } from '@companydotcom/potion';
dayjs.extend(timezone);
export const DisplayTimestamp = ({ label, timeStamp, dateFormat = 'MMMM D[,] YYYY [at] h:mm A zz', }) => (_jsxs(_Fragment, { children: [_jsx(Text, Object.assign({ textStyle: "md" }, { children: label }), void 0), _jsx(Text, { children: dayjs.unix(Math.round(timeStamp)).tz('America/New_York').format(dateFormat) }, void 0)] }, void 0));
